import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Listing3DTourCard from "@organic-return/foundation-react/src/components/Listing/Listing3DTourCard"

const VirtualTours = ({ module }) => {
    const data = useStaticQuery(graphql`
    query  {  
        allListing(filter:{hasVirtualTour:{eq: true}, exclusive:{eq: true}}) {
            nodes {
                defaultImage {
                    url
                }
                description
                tours {
                    url
                }
                path
                address {
                    street1
                }
            }
        }
      }
  `)

    const listings = data.allListing?.nodes

    return (
        <div className="virtual-tours-module w-full max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-y-8">
            {listings?.[0] && listings.map((listing, index) => (
                <Listing3DTourCard
                    key={index}
                    listing={listing}
                    linkText="VIEW COMPLETE LISTING"
                />
            ))}
        </div>
    )
}

export default VirtualTours